import {
  Component,
  ElementRef,
  inject,
  Renderer2,
  signal,
  viewChild,
  viewChildren,
} from '@angular/core';
import { GenericMessageModalProperties } from './generic-message-modal-properties.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-generic-message-modal',
  templateUrl: './generic-message-modal.component.html',
})
export class GenericMessageModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);
  private renderer2 = inject(Renderer2);

  title = viewChild<ElementRef<HTMLHeadElement>>('title');
  body = viewChild<ElementRef<HTMLHeadElement>>('body');
  btnActions = viewChildren<ElementRef<HTMLButtonElement>>('btnAction');

  properties = signal<GenericMessageModalProperties>({});

  ngAfterViewInit() {
    this.setInnerHtml(this.title()!, this.properties().title);
    this.setInnerHtml(this.body()!, this.properties().body);

    for (let index = 0; index < this.btnActions().length; index++) {
      const element = this.btnActions()[index];
      this.setInnerHtml(element, this.properties().buttons![index].label);
      this.addClass(element, this.properties().buttons![index].styleClass);
    }
  }

  closeModal() {
    this.ngbActiveModal.close();
  }

  dismissModal() {
    this.ngbActiveModal.dismiss();
  }

  executeAction(action: () => void) {
    action();
    this.ngbActiveModal.close();
  }

  private setInnerHtml(el: ElementRef, value: string | undefined) {
    if (value !== undefined) {
      this.renderer2.setProperty(el.nativeElement, 'innerHTML', value);
    }
  }

  private addClass(el: ElementRef, value: string | undefined) {
    if (value !== undefined) {
      const cssClasses = value.split(' ');
      cssClasses.forEach((cssClass) => {
        this.renderer2.addClass(el.nativeElement, cssClass);
      });
    }
  }
}
